"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAndDownloadFile = fetchAndDownloadFile;
exports.downloadFileAttributeCallback = downloadFileAttributeCallback;
exports.executeConsecutiveUpload = void 0;

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("regenerator-runtime/runtime");

var _fetchPonyfill2 = _interopRequireDefault(require("fetch-ponyfill"));

var _jsFileDownload = _interopRequireDefault(require("js-file-download"));

var _nativePromiseOnly = _interopRequireDefault(require("native-promise-only"));

var _Formio = _interopRequireDefault(require("../Formio"));

var _errorMessageIdGetters = require("./errorMessageIdGetters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _fetchPonyfill = (0, _fetchPonyfill2.default)({
  Promise: _nativePromiseOnly.default
}),
    fetch = _fetchPonyfill.fetch;

function fetchAndDownloadFile(url, fetchOptions, fileName, type) {
  return fetch(url, fetchOptions).then(function (res) {
    if (!res.ok) {
      var messageId = (0, _errorMessageIdGetters.getFileErrorMessageIdByStatus)(res.status);

      _Formio.default.handleErrorWithOuterErrorHandler(messageId);
    } else {
      return res.blob();
    }
  }).then(function (file) {
    if (file) {
      (0, _jsFileDownload.default)(file, fileName, type);
    }
  });
}

function downloadFileAttributeCallback(event, anchor) {
  if (event) {
    event.preventDefault();
  }

  if (anchor) {
    var href = anchor.href,
        anchorDataset = anchor.dataset;
    var type = anchorDataset.type,
        originalname = anchorDataset.originalname;
    var options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: '*/*'
      },
      credentials: 'include',
      responseType: 'blob'
    };
    fetchAndDownloadFile(href, options, originalname, type);
  }
}

var executeConsecutiveUpload =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(filesIterable, action) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(filesIterable === null || filesIterable === void 0 ? void 0 : filesIterable[Symbol.iterator])) {
              _context.next = 35;
              break;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = filesIterable[Symbol.iterator]();

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 19;
              break;
            }

            file = _step.value;
            _context.prev = 8;
            _context.next = 11;
            return action(file);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);
            console.error(_context.t0);

          case 16:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t1 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            _context.next = 36;
            break;

          case 35:
            console.error("'iterable' does not have an iterator");

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 21, 25, 33], [8, 13], [26,, 28, 32]]);
  }));

  return function executeConsecutiveUpload(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.executeConsecutiveUpload = executeConsecutiveUpload;